<template>
  <v-content>
    <v-container fill-height>
      <v-row align="center">
        <v-col cols="12" justify-self="center">
          <error-page :description="$vuetify.lang.t('$vuetify.page_not_found')" error="404"></error-page>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
 
<script>
import ErrorPage from "./../../components/commons/error";
export default {
  data: () => ({}),
  components: {
    ErrorPage
  }
};
</script>